import RateCalculator from '../etc/RateCalculator/RateCalculator';
import RepaymentInfoBottomSheet from '../feedback/RepaymentInfoBottomSheet/RepaymentInfoBottomSheet';
import useRepaymentInfoBottomSheet from '../../application/hooks/useRepaymentInfoBottomSheet';

const RateCalc = (preset: { maxTerm?: number }) => {
  const {
    openInfoBottomSheet,
    handleClickOpenInfoBottom,
    handleClickCloseInfoBottom,
  } = useRepaymentInfoBottomSheet();
  return (
    <>
      <RateCalculator
        isBottomSheet={false}
        onInfoIconClick={handleClickOpenInfoBottom}
        preset={preset}
      />
      <RepaymentInfoBottomSheet
        isShow={openInfoBottomSheet}
        handleClickCloseInfoBottom={handleClickCloseInfoBottom}
        isBottomSheet={true}
      />
    </>
  );
};

export default RateCalc;
